import { render } from "./OfficeEquipmentM.vue?vue&type=template&id=bc45cc82&scoped=true"
import script from "./OfficeEquipmentM.vue?vue&type=script&lang=js"
export * from "./OfficeEquipmentM.vue?vue&type=script&lang=js"

import "./OfficeEquipmentM.vue?vue&type=style&index=0&id=bc45cc82&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc45cc82"]])

export default __exports__